import { InjectionToken, Provider } from '@angular/core';

export const QUESTION_IMAGE_BUCKET_NAME = new InjectionToken<string>('Image Bucket Name');

export const QUESTION_IMAGE_BUCKET_NAME_DEFAULT = 'question-images';

export function provideQuestionImageBucketName(questionImageBucketName: string): Provider[] {
  return [
    {
      provide: QUESTION_IMAGE_BUCKET_NAME,
      useValue: questionImageBucketName,
    },
  ];
}
